// Reducers
import account from './account'
import authentication from './authentication'
import notice from './notice'
import system from './system'

// Functions (Local)
const reduceReducers = (...reducers) => (previousState, value, ...args) => reducers.reduce(
	(newState, reducer) => reducer(newState, value, ...args),
	previousState
)

// Reducer: Application
const reducer = reduceReducers(
	account,
	authentication,
	notice,
	system
)

// Export
export default reducer
